// src/store/UserPresenceStore.js

import { create } from "zustand";
import apiFactory from "../api"; // Giả sử bạn có file api factory

export const useUserPresenceStore = create((set, get) => ({
  userStatuses: {},
  isLoading: true,
  error: null,

  fetchStatuses: async () => {
    try {
      set({ isLoading: true, error: null });

      const response = await apiFactory.userChatApi.getSubscribeStatus();

      if (response?.status === 200 && response?.data) {
        set({ userStatuses: response.data, isLoading: false });
      } else {
        throw new Error("Failed to fetch statuses");
      }
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },

  updateUserStatus: (userId, status) => {
    set((state) => ({
      userStatuses: {
        ...state.userStatuses,
        [userId]: status,
      },
    }));
  },

  getUserStatus: (userId) => {
    return get().userStatuses[userId];
  },
}));
